import { render, staticRenderFns } from "./FacebookActionForm.vue?vue&type=template&id=fbdbb5b8&scoped=true"
import script from "./FacebookActionForm.vue?vue&type=script&lang=js"
export * from "./FacebookActionForm.vue?vue&type=script&lang=js"
import style0 from "./FacebookActionForm.vue?vue&type=style&index=0&id=fbdbb5b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdbb5b8",
  null
  
)

export default component.exports